import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { findIndex, filter, each, findLast } from 'lodash';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { Button, Modal, ProgressBar } from 'react-bootstrap';
import { fetchReports, deleteReports, generateReport } from '../../AdminActions';
import ProgressBar2 from '../../../../components/progress-bar';
import DateTimeDisplay from '../../../../components/date-time-display';
import Pusher from '../../../../components/pusher';
import Counter from '../../../../components/counter';
import NumberDisplay from '../../../../components/number-display';

class ReportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      loaded: false,
      reports: [],
      showModal: false,
      generating: false,
      deletingIds: {},
      flash: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.requestGenerate = this.requestGenerate.bind(this);
    this.handleSocket = this.handleSocket.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  openModal() {
    this.setState({ showModal: true });
  }

  closeModal() {
    this.setState({ showModal: false });
  }


  confirmDelete(report) {
    const id = report.reportId;
    if (!this.state.deletingIds[id]) {
      this.setState({
        deletingIds: {
          ...this.state.deletingIds,
          [id]: true,
        },
      }, () => {
        this.props.dispatch(deleteReports(id))
          .then(
            () => {
              const newReports = filter(this.state.reports, (r) => {
                return r.reportId !== id;
              });
              this.setState({
                reports: newReports,
                deletingIds: {
                  ...this.state.deletingIds,
                  [id]: false,
                },
              });
              const el = <div>Report deleted!</div>;
              this.context.addNotification(el, { type: 'success', autoClose: true });
            },
            () => {
              // TODO: display error
              this.setState({
                deletingIds: {
                  ...this.state.deletingIds,
                  [id]: false,
                },
              });
            }
          );
      });
    }
  }

  handleSocket(evt) {
    const { reportId } = evt;
    const newReports = [...this.state.reports];
    const idx = findIndex(newReports, { reportId });
    if (idx >= 0) {
      newReports[idx] = {
        ...newReports[idx],
        isNew: true,
        ...evt,
      };
    } else {
      newReports.push({
        ...evt,
        isDone: evt.isSuccess === true,
        created_at: moment().toDate(),
        isNew: true,
      });
    }
    
    if (evt.organization) {
      console.log(evt.organization);
    }
    if (evt.isSuccess) {
      const el = <div>New report generated!</div>;
      this.context.addNotification(el, { type: 'success', autoClose: true });
      this.loadReports();
    } else if (evt.isError && evt.error) {
      const el = <div>{evt.error}</div>;
      this.context.addNotification(el, { type: 'error', autoClose: false });
    }
    this.setState({
      reports: newReports, generating: evt.isProcessing,
      flash: !this.state.flash,
    });
  }


  requestGenerate() {
    this.setState({ generating: true }, () => {
      this.closeModal();
      this.props.dispatch(generateReport())
        .then(
          () => {
            // this.setState({ generating: false });
            // this.loadReports();
          },
          (e) => {
            this.setState({ generating: false });
          },
        );
    });
  }

  componentDidMount() {
    this.setState({ loading: true, loaded: false, reports: [] }, () => {
      this.loadReports();
    });
  }

  loadReports() {
    this.props.dispatch(fetchReports())
      .then(
        (results) => {
          const lastSuccessReport = findLast(results, { isSuccess: true });
          const reports = [];
          if (lastSuccessReport) {
            reports.push(lastSuccessReport);
          }
          each(results, (result) => {
            if (result.isProcessing) {
              reports.push(result);
            }
          });
          this.setState({ loading: false, loaded: true, reports });
        },
        (e) => {
          this.setState({ loading: false, loaded: false, reports: [] });
        },
      );
  }
  
  renderButton() {
    const { generating } = this.state;
    if (generating) {
      return null;
    }
    return (
      <div>
        
        <Button disabled={generating} bsStyle="primary" onClick={this.openModal}>Generate new Report</Button>

        <Modal show={this.state.showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>Generate New Report</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>This will generate a new reports for all organizations.</p>
            <p>The process may take awhile to complete.</p>
          </Modal.Body>
          <Modal.Footer className="clearfix">
            <Button className="pull-left" bsStyle="link" onClick={this.closeModal}>Cancel</Button>

            <Button className="pull-right" disabled={generating} onClick={this.requestGenerate} bsStyle="primary" >
              <span>Start <Fa name="arrow-right" /></span>
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }

  renderResults() {
    const { reports, deletingIds } = this.state;
    if (!reports || reports.length === 0) {
      return null;
    }

    const rows = [];
    let hasSuccess = false;
    each(reports, (report) => {
      const isProcessing = report.isProcessing && !report.isError && !report.isSuccess;
      const syncPercentage = report.percentage;
      const isSuccess = report.isSuccess;
      const deleting = deletingIds[report.reportId] === true;
      if (isSuccess) {
        hasSuccess = true;
      }
      let comp = (
        <span>Current report: generated on <DateTimeDisplay value={report.created_at} format="shortWithTimeAt" /></span>
      );
      if (isSuccess && !deleting) {
        comp = (
          <span className={report.isDone ? 'animated flash' : ''}><a href={`/api/reports/${report.reportId}`} target="_blank">{comp} <Fa name="download" /></a></span>
        );
      }
      let orgLabel= null;
      if (isProcessing && report.organization && report.organization.name) {
        orgLabel = (<span> - processing {report.organization?.name} data</span>);
      }
      const { isNew } = report;

      const row = (
        <tr key={report.reportId}>
          <td colSpan={isNew ? 2 : 1}>
            <div>
              {!isNew && comp}
              {isProcessing && 
                <span className="text-muted">
                  <Fa name="circle" className={`${this.state.flash ? 'animated flash' : ''} text-success`} /> Generating new report: <Counter value={syncPercentage}><NumberDisplay suffix="%" precision={1} value={syncPercentage} /></Counter> {orgLabel}
                </span>
              } 
            </div>
            {isProcessing && 
              <div>
                <ProgressBar>
                  <ProgressBar active bsStyle="success" striped now={syncPercentage} />
                </ProgressBar>
              </div>
            }
          </td>
          {!isNew &&
            <td>
              {report.auth !== undefined && <span>{report.auth.first_name} {report.auth.last_name}</span>}
            </td>
          }
        </tr>
      );
      rows.push(row);
    });

    return (
      <div>
        <table className="table table-striped table-bordered">
          {hasSuccess &&
            <thead>
              <tr>
                <th>Reports</th>
                <th width="150">By</th>
              </tr>
            </thead>
          }
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }

  render() {
    const { loading, loaded } = this.state;

    return (
      <div>
        <Helmet title="Reports" />
        <p />
        <div className="container">
          {loading && <ProgressBar2 />}
          <Pusher event="reportSocket" handler={this.handleSocket} />
          {!loading && loaded && this.renderResults()}
          {!loading && loaded && this.renderButton()}
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
  };
}

ReportPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

ReportPage.defaultProps = {
};

ReportPage.contextTypes = {
  router: PropTypes.shape({}),
  addNotification: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(ReportPage);
